import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange} from '@angular/core';

@Component({
  selector: 'app-view-service-package',
  templateUrl: './view-service-package.component.html',
  styleUrls: ['./view-service-package.component.scss']
})
export class ViewServicePackageComponent implements OnInit {

  @Input() servicePackageData;
  @Input() isShowEditbtn = true;
  @Output() submitEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.init();
  }


  init() {
    console.log("Service package data : ", this.servicePackageData);
  }

  editCLicked() {
    this.submitEmitter.emit(JSON.parse(JSON.stringify(this.servicePackageData)));
  }

  closeClicked() {
    this.closeEmitter.emit(JSON.parse(JSON.stringify(this.servicePackageData)));
  }
}
